module.exports = __webpack_public_path__ + "img/incidentInfoYellow.8acac769.svg";